import { Divider } from '@mui/material';

import SideBarItem from '../parts/SideBarItem';
import { MemoSideBarCloseButton } from '../parts/SideBarButton';

import { UserInfoType } from '../../type/UserInfoType';
import { StyledDrawer, StyledDrawerHeader } from '../styled/DrawerStyled';

type SideBarPropsType = {
	drawerOpen: boolean;
	handleDrawerClose: () => void;
	userInfo: UserInfoType;
};

/**
 * サイドバー
 */
const SideBar = (props: SideBarPropsType) => {
	const { drawerOpen, handleDrawerClose, userInfo } = props;

	return (
		<StyledDrawer variant="temporary" anchor="left" open={drawerOpen}>
			<StyledDrawerHeader>
				<MemoSideBarCloseButton handleDrawerClose={handleDrawerClose} />
			</StyledDrawerHeader>
			<Divider />
			<SideBarItem permissionNum={userInfo.permission} handleDrawerClose={handleDrawerClose} />
		</StyledDrawer>
	);
};

export default SideBar;
